import { useTranslation } from 'react-i18next';

import { EmptyStateIllustration } from '~/assets/illustrations';

import { ErrorPage } from './ErrorPage';
import { Link } from './Link';

/**
 * Renders an error boundary component at the root level of the router.
 *
 * @return {JSX.Element} The rendered error boundary component.
 */

export const RootErrorBoundary = ({ error }) => {
  const { t } = useTranslation('admin-webapp');

  switch (String(error?.status)) {
    case '404': {
      return (
        <ErrorPage
          callToAction={
            <Link className="px-16 py-4 text-xl font-medium" to="/">
              {t(($) => $.error404.goToHomePageButton.text)}
            </Link>
          }
          errorCode="404"
          message={t(($) => $.error404.message)}
          title={t(($) => $.error404.title)}
        />
      );
    }

    case '401':
    case '403': {
      return (
        <ErrorPage
          illustration={<EmptyStateIllustration className="h-64" />}
          message={t(($) => $.error401.message)}
          title={t(($) => $.error401.title)}
        />
      );
    }

    case '502':
    case '503': {
      return (
        <ErrorPage
          illustration={<EmptyStateIllustration className="h-64" />}
          message={t(($) => $.error503.message)}
          title={t(($) => $.error503.title)}
        />
      );
    }

    default: {
      return (
        <ErrorPage
          message={t(($) => $.error.generic.message)}
          title={t(($) => $.error.generic.title)}
        />
      );
    }
  }
};
